import React, { useState, useEffect } from "react";
import "./style.css";

const ClassManager = () => {
  const [classes, setClasses] = useState([]);
  const [loading, setLoading] = useState(false);
  const [editingKey, setEditingKey] = useState(null);
  const [editForm, setEditForm] = useState({});
  const [searchBatchNo, setSearchBatchNo] = useState("");
  // Fetch all classes
  const fetchClasses = async () => {
    setLoading(true);
    try {
      const res = await fetch("https://elearn-api.onrender.com/api/getAllClasses");
      const data = await res.json();
      setClasses(data);
    } catch (err) {
      console.error("Error fetching classes:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchClasses();
  }, []);

  // Composite key
  const getKey = (c) => `${c.BatchNo}_${c.CourseStartDate}`;

  // Delete
  const handleDelete = async (BatchNo, CourseStartDate) => {
    if (!window.confirm("Are you sure you want to delete this class?")) return;
    try {
      await fetch(
        `https://elearn-api.onrender.com/api/deleteClass/${BatchNo}/${CourseStartDate.split("T")[0]}`,
        { method: "DELETE" }
      );
      setClasses(classes.filter(c =>
        !(c.BatchNo === BatchNo && c.CourseStartDate === CourseStartDate)
      ));
    } catch (err) {
      console.error("Error deleting class:", err);
    }
  };

  // Start editing
  const handleEdit = (c) => {
    setEditingKey(getKey(c));
    setEditForm({
      ...c,
      CourseStartDate: c.CourseStartDate.split("T")[0],
      CourseEndDate: c.CourseEndDate?.split("T")[0] || ""
    });
  };

  // Handle input
  const handleChange = (e) => {
    setEditForm({ ...editForm, [e.target.name]: e.target.value });
  };

  // Update
  const handleUpdate = async (e) => {
    e.preventDefault();
    try {
      await fetch(
        `https://elearn-api.onrender.com/api/updateClass/${editForm.BatchNo}/${editForm.CourseStartDate}`,
        {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(editForm),
        }
      );
      setEditingKey(null);
      fetchClasses();
    } catch (err) {
      console.error("Error updating class:", err);
    }
  };
  const filteredClasses = classes.filter(c =>
    c.BatchNo?.toLowerCase().includes(searchBatchNo.toLowerCase())
  );
  return (
    <div className="class-manager-container">
      <h1 className="cm-title">Class Management</h1>
     <div className="cm-search">
  <input
    type="text"
    placeholder="🔍 Search by Batch No..."
    value={searchBatchNo}
    onChange={(e) => setSearchBatchNo(e.target.value)}
  />
</div>
      {loading ? (
        <p className="cm-loading">Loading classes...</p>
      ) : (
        <div className="cm-cards">
          {filteredClasses.map((c) => (
            <div className="cm-card" key={getKey(c)}>
              {editingKey === getKey(c) ? (
                <>
                  <div className="cm-field">
                    <label>Batch No:</label>
                    <input
                      name="BatchNo"
                      value={editForm.BatchNo || ""}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="cm-field">
                    <label>Class Name:</label>
                    <input
                      name="ClassName"
                      value={editForm.ClassName || ""}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="cm-field">
                    <label>Course Name:</label>
                    <input
                      name="CourseName"
                      value={editForm.CourseName || ""}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="cm-field">
                    <label>Start Date:</label>
                    <input
                      type="date"
                      name="CourseStartDate"
                      value={editForm.CourseStartDate || ""}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="cm-field">
                    <label>End Date:</label>
                    <input
                      type="date"
                      name="CourseEndDate"
                      value={editForm.CourseEndDate || ""}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="cm-field">
                    <label>Trainer:</label>
                    <input
                      name="Trainer"
                      value={editForm.Trainer || ""}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="cm-field">
                    <label>Assessor1:</label>
                    <input
                      name="Assessor1"
                      value={editForm.Assessor1 || ""}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="cm-field">
                    <label>Assessor2:</label>
                    <input
                      name="Assessor2"
                      value={editForm.Assessor2 || ""}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="cm-field">
                    <label>Examiner:</label>
                    <input
                      name="Examiner"
                      value={editForm.Examiner || ""}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="cm-field">
                    <label>Language:</label>
                    <input
                      name="Language"
                      value={editForm.Language || ""}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="cm-field">
                    <label>Location:</label>
                    <input
                      name="Location"
                      value={editForm.Location || ""}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="cm-buttons">
                    <button className="cm-btn cm-save-btn" onClick={handleUpdate}>Save</button>
                    <button className="cm-btn cm-cancel-btn" onClick={() => setEditingKey(null)}>Cancel</button>
                  </div>
                </>
              ) : (
                <>
                  <p><strong>Batch No:</strong> {c.BatchNo}</p>
                  <p><strong>Class Name:</strong> {c.ClassName}</p>
                  <p><strong>Course:</strong> {c.CourseName}</p>
                  <p><strong>Start Date:</strong> {c.CourseStartDate.split("T")[0]}</p>
                  <p><strong>End Date:</strong> {c.CourseEndDate?.split("T")[0]}</p>
                  <p><strong>Trainer:</strong> {c.Trainer}</p>
                  <p><strong>Assessor1:</strong> {c.Assessor1}</p>
                  <p><strong>Assessor2:</strong> {c.Assessor2}</p>
                  <p><strong>Examiner:</strong> {c.Examiner}</p>
                  <p><strong>Language:</strong> {c.Language}</p>
                  <p><strong>Location:</strong> {c.Location}</p>
                  <div className="cm-buttons">
                    <button className="cm-btn cm-edit-btn" onClick={() => handleEdit(c)}>Edit</button>
                    <button className="cm-btn cm-delete-btn" onClick={() => handleDelete(c.BatchNo, c.CourseStartDate)}>Delete</button>
                  </div>
                </>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ClassManager;
